import type { ComponentChildren, HTMLAttributes } from 'preact'

type Variant = 'primary' | 'secondary'

interface Props extends Omit<HTMLAttributes<HTMLButtonElement>, 'class' | 'type'> {
  variant?: Variant
  children?: ComponentChildren
}

export function Button({ variant = 'primary', children, ...rest }: Props) {
  const className = variant === 'secondary' ? 'btn secondary' : 'btn'

  return (
    <button type="button" class={className} {...rest}>
      {children}
    </button>
  )
}

export function ButtonRow({ children }: { children?: ComponentChildren }) {
  return <div class="btn-row">{children}</div>
}
